export default __webpack_public_path__ + "static/media/3.2ca65c09.jpg";